import { ff } from '@atlassian/jira-feature-flagging';
import type { ChartData } from '../../types';

export const evaluateTargetDependencyDate = (targetItem: ChartData) => {
	const { startDate: start, dueDate: due } = targetItem;

	if (
		ff('timeline-bar-start-date-after-due-date_ddpds') &&
		due !== undefined &&
		start !== undefined &&
		due < start
	) {
		return due;
	}
	return start;
};

export const evaluateSourceDependencyDate = (sourceItem: ChartData) => {
	const { startDate: start, dueDate: due } = sourceItem;

	if (
		ff('timeline-bar-start-date-after-due-date_ddpds') &&
		due !== undefined &&
		start !== undefined &&
		due < start
	) {
		return start;
	}
	return due;
};
